import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentParticipants = new CRUD('tournament-participants', 'superior-judge')

export default Object.assign(
    tournamentParticipants,
    {
        reducers: {
            ...tournamentParticipants.reducers
        },

        notAssigned: (id) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/not-assigned`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        copy: (id, id_tournament) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/copy-to/${id_tournament}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        copyToDances: (id, id_tournament) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/copy-to-dances/${id_tournament}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        disqualify: (id, status) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participants/${id}/disqualify/${status}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        setPersonalDiscount: (id, discount) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participants/${id}/personal-discount`, discount)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        deletePersonalDiscount: (id) => {
            return async (dispatch) => {
                try {
                    return axios.delete(`/superior-judge/tournament-participants/${id}/personal-discount`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        unlink: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/unlink`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        recalculate: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/recalculate`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        verifyVote: (id, verify) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participants/${id}/verify-vote/${verify}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        award: (id, type) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.get(`/superior-judge/tournament-participants/award/${id}/${type}`, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        notify: (message, filters={}) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-participants/notify`, {
                        params: {
                            'message': message,
                            'filters': filters
                        }
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        protocols: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/protocols`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        approveVotePayment: (id) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participants/${id}/approve-vote-payment`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        sendMessage: (id, message) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participants/${id}/message`, {message: message})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        setRanks: (id, participants) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participants/ranks`, {
                        id: id,
                        participants: participants
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        import: (data) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participants/import`, data, {headers: {
                        'Content-Type': 'multipart/form-data'
                    }})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        music: (data) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participants/music`, data, {headers: {
                        'Content-Type': 'multipart/form-data'
                    }})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        payment: (data) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.post(`/superior-judge/tournament-participants/payment`, data, {headers: {
                        'Content-Type': 'multipart/form-data'
                    }})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        report: (id) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/report`, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        customReportTopFestPayments: (id) => {
            return async (dispatch) => {
                dispatch(tournamentParticipants.slice.actions.startLoading());
                try {
                    return axios.get(`/superior-judge/tournament-participants/${id}/custom-reports/top-fest-payments`, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
